import { render, staticRenderFns } from "./wechatInsurance.vue?vue&type=template&id=d1f961b4&scoped=true&"
import script from "./wechatInsurance.vue?vue&type=script&lang=js&"
export * from "./wechatInsurance.vue?vue&type=script&lang=js&"
import style0 from "./wechatInsurance.vue?vue&type=style&index=0&id=d1f961b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f961b4",
  null
  
)

export default component.exports